module.exports = __webpack_public_path__ + "img/876296-47-8.fcaaf979.png";